import { render, staticRenderFns } from "./ModifierSelections.vue?vue&type=template&id=6a115548&scoped=true&"
import script from "./ModifierSelections.vue?vue&type=script&lang=js&"
export * from "./ModifierSelections.vue?vue&type=script&lang=js&"
import style0 from "./ModifierSelections.vue?vue&type=style&index=0&id=6a115548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a115548",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconNone: require('/opt/build/repo/components/icons/IconNone.vue').default,ModifierSelections: require('/opt/build/repo/components/order/ModifierSelections.vue').default})
